import { gql } from '@apollo/client';
import React, { FC } from 'react';
import { Badge, BadgeTheme } from '@moda/om';

import './ProductDetailsTagsSection.scss';

const ENABLE_BADGES = false;

export const PDP_BADGES_FRAGMENT = gql`
  fragment PDPBadgesFragment on VariantData {
    badges
  }
`;

interface Props {
  tag: string | null;
  badges: BadgeTheme[];
}

export const ProductDetailsTagsSection: FC<Props> = ({ tag, badges }) => (
  <div className="ProductDetailsTagsSection">
    {tag && (
      <Badge className="ProductDetailsTagsSection__item ProductDetailsTagsSection__tag">
        {tag}
      </Badge>
    )}

    {/* TODO -- Enable the product badges once their API logic is finished and behaving correctly */}
    {ENABLE_BADGES &&
      badges.map(badge => (
        <Badge className="ProductDetailsTagsSection__item" key={badge} theme={badge}>
          {badge}
        </Badge>
      ))}
  </div>
);
